import { useFormikContext } from "formik";
import React, { useState, useEffect } from "react";
import { labelName } from "../../utils/functions";
import TextFieldStyles from "../Input/TextField/TextField.module.css";
import DimensionFieldStyles from "./Dimension.module.css";
import ErrorMessage from "../Input/ErrorrMessage";

const unitOfMeasure = ["Kilometers", "Meters", "Miles", "Yards", "Feet"];

export default function Dimension({ field_label, displayLabel, parent, isRequired, initialValue }) {
    //uom: Meters,length: 45,width: 76,height: 97
  const { setFieldValue } = useFormikContext();
  const name = parent ? `${parent}.${field_label}` : field_label;

  const [dimension, setDimension] = useState(parseDimension(initialValue));

  const dimensionToSave = Object.entries(dimension)
    .map(([key, value]) => `${key}: ${value?.trim()}`)
    .join(",");

  useEffect(() => {
    setFieldValue(name, dimensionToSave);
  }, [dimension, name, setFieldValue]);

  // Function to update a specific index
  const updateDimension = (key, value) => {
    setDimension(prev => ({
        ...prev,
        [key]: value
    }));
  };

    function parseDimension(value) {
        const defaults = {
            uom: "Kilometers",
            length: "",
            width: "",
            height: "",
        };

        if (!value) return defaults;

        return value.split(",").reduce((acc, item) => {
                const [key, val] = item.split(":").map(s => s.trim());
                if (key && val !== undefined) {
                acc[key] = val;
                }
                return acc;
            }, { ...defaults });
    };

return (
    <div className={TextFieldStyles.inputContainer}>
        <div
            className="label-container"
            style={{ display: "flex", justifyContent: "space-between" }}
        >
            <label htmlFor="textarea" className={TextFieldStyles.label}>
                {labelName(displayLabel || field_label)}
                {isRequired === "true" && (
                    <span style={{ color: "#d32f2f", padding: 0 }}>*</span>
                )}
            </label>
        </div>
        <div style={{ fontFamily: "Arial, sans-serif" }}>
            <input type="hidden" name={name} value={dimensionToSave} />
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <div style={{ display: "grid", gap: ".8em", marginRight: "1em" }}>
                    <label style={{width: "max-content"}} className={TextFieldStyles.label}>Unit of Measure</label>
                    <select
                        style={{
                            width: "min-content",
                            fontFamily: "Arial, sans-serif",
                            border: "none",
                            borderBottom: "none",
                            outline: "none",
                        }}
                        value={dimension.uom}
                        onChange={(e) => updateDimension("uom", e.target.value)}       
                    >
                        {unitOfMeasure.map((unit) => (
                            <option key={unit} value={unit}>
                                {unit}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className={TextFieldStyles.label}>Length</label>
                    <input
                        type="number"
                        placeholder="Enter Length"
                        className={DimensionFieldStyles.input}
                        value={dimension.length}
                        onChange={(e) => updateDimension("length", e.target.value)}
                    />
                </div>
                <div>
                    <label>Width</label>
                    <input
                        type="number"
                        placeholder="Enter Width"
                        className={DimensionFieldStyles.input}
                        value={dimension.width}
                        onChange={(e) => updateDimension("width", e.target.value)}
                    />
                </div>
                <div>
                    <label>Height</label>
                    <input
                        type="number"
                        placeholder="Enter Height"
                        className={DimensionFieldStyles.input}
                        value={dimension.height}
                        onChange={(e) => updateDimension("height", e.target.value)}
                    />
                </div>
            </div>
        </div>
        <ErrorMessage name={name} />
    </div>
);
}
